export default __webpack_public_path__ + "static/media/slot17.ab7137e9.png";